import { useMemo } from 'react';
import { useGetUserQuery, useGetUserSettingsQuery } from '../../modules/user/api/user-api';

export const useCheckTotpRequirements = (): boolean => {
  const { data: userSettings } = useGetUserSettingsQuery();
  const { data: currentUser } = useGetUserQuery();

  return useMemo(() => {
    if (!userSettings || !currentUser) {
      return false;
    }

    const totpRequired =
      typeof userSettings.totpRequired === 'string'
        ? userSettings.totpRequired === 'true'
        : Boolean(userSettings.totpRequired);

    return totpRequired && !currentUser.totpEnabled;
  }, [userSettings, currentUser]);
};
